<template>

    <section class="membership_packages_wrp" :class="isLoggedIn ? 'package_list_login_wrp' : ''">
        <div class="membership_packages_bg_wrp"
            :class="selfUserInfo && selfUserInfo.pro_payment || selfUserInfo && selfUserInfo.auto_payment ? 'box_style_change' : ''">
            <router-link to="/" class="home_rdrtc_cross">
                <i aria-hidden="true" class="fa fa-times-circle-o mbl_cross"></i>
            </router-link>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-12">
                        <h2 class="membership_packages_heading text-center">Upgrade your Digital Health Ecosystem</h2>
                        <h4 class="membership_packages_subheading text-center">Choose a plan that will enhance your AI
                            and Machine Learning research purposes</h4>
                    </div>
                </div>
                <div class="row mt-3 packages_row">
                    <div class="col-md-3">
                        <div class="card">
                            <div class="card-header">
                                <h5 class="card-title text-center">Natural Package</h5>
                                <h5 class="card-subtitle text-center">Introductory access to Lymphomap </h5>
                                <h6 class="h1 text-white text-center mb-0">Free
                                </h6>
                            </div>
                            <div class="card-body">
                                <ul class="packages_features_list">
                                    <li><i class="fa fa-check"></i>2 AI Case Analyses (trial access)</li>
                                    <li><i class="fa fa-check"></i>Access to core platform features and workspace tools
                                    </li>
                                    <li><i class="fa fa-check"></i>Access to basic collaboration features</li>
                                    <li><i class="fa fa-check"></i>Preview access to Awerack – Lymphomap’s research
                                        database & global collaboration networkz</li>
                                </ul>
                                <template v-if="isLoggedIn">
                                    <template v-if="selfUserInfo">
                                        <template v-if="selfUserInfo && selfUserInfo.regular_payment">
                                            <template v-if="selfUserInfo && selfUserInfo.regular_payment">
                                                <button class="btn btn-primary btn-block active">Active</button>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card">
                            <div class="card-header">
                                <h5 class="card-title text-center">Supervised Package</h5>
                                <h5 class="card-subtitle text-center">For active users and early researchers</h5>
                                <h6 class="h1 text-white text-center mb-0">$19<span
                                        class="h6 text-white-50">(USD)/month</span></h6>
                            </div>
                            <div class="card-body">
                                <ul class="packages_features_list">
                                    <li><i class="fa fa-check"></i>5 AI Case Analyses / month</li>
                                    <li><i class="fa fa-check"></i>AI powered diagnostic & prognostic insights </li>
                                    <li><i class="fa fa-check"></i>Full access to platform and clinical workspace</li>
                                    <li><i class="fa fa-check"></i>Limited access to Awerack – Lymphomap’s research
                                        database & global
                                        collaboration network</li>
                                    <li><i class="fa fa-check"></i>Standard technical support</li>
                                </ul>
                                <template v-if="isLoggedIn">
                                    <template v-if="selfUserInfo">
                                        <template v-if="selfUserInfo && !selfUserInfo.pro_payment">
                                            <template v-if="selfUserInfo && selfUserInfo.auto_payment">
                                                <button class="btn btn-primary btn-block active">Active</button>
                                                <!-- <div class="membership_cancel text-center"
                                                    v-if="!selfUserInfo.cancel_subscription">
                                                    <a href="javascript:void(0)" class="membership_cancel_txt"
                                                        @click="cancelMembershipPopupOpen">Cancel Subscription</a>
                                                </div> -->
                                            </template>
                                            <template v-else>
                                                <template
                                                    v-if="getPackageListDataResults && getPackageListDataResults.length > 0">
                                                    <router-link class="btn btn-block btn-primary"
                                                        :to="{ name: 'paymentCheckoutSupervisedPackage', query: { plan_id: getPackageListDataResults[0].plan_id } }">Subscribe
                                                        Now</router-link>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card">
                            <div class="card-header">
                                <h5 class="card-title text-center">Neural Package</h5>
                                <h5 class="card-subtitle text-center">Advanced AI for serious research and precision
                                    oncology use</h5>
                                <h6 class="h1 text-white text-center mb-0">
                                    $49<span class="h6 text-white-50">(USD)/month (Recommended)

                                    </span></h6>
                                <template
                                    v-if="selfUserInfo && !selfUserInfo.auto_payment && selfUserInfo && !selfUserInfo.pro_payment">
                                    <template v-if="selfUserInfo && selfUserInfo.trial_counter == '0'">
                                        <p class="seven_days_free_trial_alert">7 Days Free Trial</p>
                                    </template>
                                </template>
                            </div>
                            <div class="card-body">
                                <ul class="packages_features_list">
                                    <li><i class="fa fa-check"></i>15 AI Case Analyses / month</li>
                                    <li><i class="fa fa-check"></i>Advanced AI reports & deeper insights</li>
                                    <li><i class="fa fa-check"></i>Full access to platform & clinical workspace</li>
                                    <li><i class="fa fa-check"></i>Full access to Awerack – Lymphomap’s research
                                        database & global
                                        collaboration network</li>
                                    <li><i class="fa fa-check"></i>Priority processing</li>
                                    <li><i class="fa fa-check"></i>Data insights & analytics</li>
                                    <li><i class="fa fa-check"></i>Priority support</li>
                                    <li><i class="fa fa-check"></i>Access to AI tutorials & collaborative learning
                                        resources</li>
                                </ul>
                                <template v-if="isLoggedIn">
                                    <template v-if="selfUserInfo">
                                        <template v-if="selfUserInfo && selfUserInfo.pro_payment">
                                            <button class="btn btn-primary btn-block active">Active</button>
                                            <!-- <div class="membership_cancel text-center"
                                                v-if="!selfUserInfo.cancel_subscription">
                                                <a href="javascript:void(0)" class="membership_cancel_txt"
                                                    @click="cancelMembershipPopupOpen">Cancel Subscription</a>
                                            </div> -->
                                        </template>
                                        <template v-else>
                                            <template v-if="selfUserInfo && selfUserInfo.auto_payment">
                                                <template
                                                    v-if="getPackageListDataResults && getPackageListDataResults.length > 0">
                                                    <router-link class="btn btn-block btn-primary"
                                                        :to="{ name: 'paymentCheckoutUpgradeNowNeuralPackage', query: { plan_id: getPackageListDataResults[2].plan_id } }">Upgrade
                                                        for only 3$</router-link>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="selfUserInfo && selfUserInfo.trial_counter == '0'">
                                                    <template
                                                        v-if="getPackageListDataResults && getPackageListDataResults.length > 0">
                                                        <router-link class="btn btn-block btn-primary"
                                                            :to="{ name: 'freeTrialPaymentCheckout', query: { plan_id: getPackageListDataResults[1].plan_id } }">7-Days
                                                            Free Trial</router-link>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template
                                                        v-if="getPackageListDataResults && getPackageListDataResults.length > 0">
                                                        <router-link class="btn btn-block btn-primary"
                                                            :to="{ name: 'paymentCheckoutNeuralPackage', query: { plan_id: getPackageListDataResults[3].plan_id } }">Subscribe
                                                            Now</router-link>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card">
                            <div class="card-header">
                                <h5 class="card-title text-center">Clinical Neural Suite</h5>
                                <h5 class="card-subtitle text-center">AI powered oncology for hospitals and institutions
                                </h5>
                                <h6 class="h1 text-white text-center mb-0"
                                    style="font-size: 28px;margin-top: 0;padding-top: 5px;">
                                    Custom Pricing<span class="h6 text-white-50"
                                        style="display: block;font-size:16px;margin: 0;">(Contract
                                        Based)</span></h6>
                            </div>
                            <div class="card-body">
                                <h3 class="listing_title">Advanced Clinical Integration and AI-Driven Research</h3>
                                <ul class="packages_features_list">
                                    <li><i class="fa fa-check"></i>Clinical Pilot Deployment (Validation phase)</li>
                                    <li><i class="fa fa-check"></i>AI-Powered Case Analysis and Decision Support</li>
                                    <li><i class="fa fa-check"></i>Professional Dashboard and Workflow Integration</li>
                                    <li><i class="fa fa-check"></i>Scalable Usage-Based Model</li>
                                    <li><i class="fa fa-check"></i>Research and Data Collaboration Opportunities</li>
                                    <li><i class="fa fa-check"></i>Dedicated Technical Support</li>
                                </ul>
                                <button class="btn request_demo_btn btn-danger" @click="bookReqAccessMethod">Request a
                                    Demo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-4" v-if="!isLoggedIn">
                    <div class="col-sm-12 text-center">
                        <router-link class="login_signup_btn_transparent" style="padding:10px 40px"
                            :to="{ name: 'signupPage' }">Sign
                            Up/Login</router-link>
                    </div>
                </div>
            </div>
        </div>
        <cancel-membership v-if="cancelMembershipPopupState"></cancel-membership>
        <div class="book_req_section" ref="demoSection" v-if="requestForDemoPopupState">
            <request-for-demo></request-for-demo>
        </div>
    </section>
</template>

<script>
/* eslint-disable */

import { bus } from '@/main';
import cancelMembershipPopup from '@/components/private/package/cancel-membership-popup/';
import requestForDemoPopup from '@/components/public/request-for-demo-popup/';
import { mapGetters } from 'vuex';

export default {
    name: 'membership-packages-page',
    components: {
        'cancel-membership': cancelMembershipPopup,
        'request-for-demo': requestForDemoPopup
    },
    props: [],
    data() {
        return {
            isLoggedIn: null,
            selfUserInfo: null,
            getPackageListData: null,
            getPackageListDataResults: [],
            cancelMembershipPopupState: false,
            requestForDemoPopupState: false
        }
    },
    computed: {
        ...mapGetters([
            'selfUserInfoGetters',
            'getAllPlansListGetters'
        ]),
        getUserDetailsAgainFun() {
            this.selfUserInfo = this.$store.getters.selfUserInfoGetters.data
            return;
        },
        checkUserLogin() {
            this.isLoggedIn = this.$store.getters.isAuthenticated
            return;
        },
        getPackageListDataFunc() {
            this.getPackageListData = this.$store.getters.getAllPlansListGetters
            return;
        },
        setInitialStatesOfPlanFunc() {
            if (this.getPackageListData) {
                this.getPackageListDataResults = this.getPackageListData.data
            }
            return;
        }
    },
    mounted() {
        this.checkUserLogin;
        this.getPackageListDataFunc;
        this.setInitialStatesOfPlanFunc;
        if (this.isLoggedIn) {
            this.$store.dispatch('fetchCurrentUserInfo');
        }
        bus.$on('cancelMembershipPopupStateBus', (data) => {
            this.cancelMembershipPopupState = data;
        })
    },
    methods: {
        cancelMembershipPopupOpen() {
            this.cancelMembershipPopupState = true;
            document.body.classList.add('body_right_scroll_remove');
        },
        bookReqAccessMethod() {
            this.requestForDemoPopupState = true;
            this.$nextTick(() => {
                this.$refs.demoSection.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            });
        }
    },
    watch: {
        getUserDetailsAgainFun() {
            return this.$store.getters.selfUserInfoGetters;
        },
        checkUserLogin() {
            return this.$store.getters.isAuthenticated
        },
        getPackageListDataFunc() {
            return this.$store.getters.getAllPlansListGetters;
        },
        setInitialStatesOfPlanFunc() {
            if (this.getPackageListData) {
                this.getPackageListDataResults = this.getPackageListData.data
            }
            return;
        }
    },
    beforeCreate: function () {
        document.body.classList.add('left_sidebaar_disabled_for_page');
        document.body.classList.add('public_page_for_wrp_img');
    },
    beforeRouteLeave: function (to, from, next) {
        document.body.classList.remove('left_sidebaar_disabled_for_page');
        document.body.classList.remove('public_page_for_wrp_img');
        window.scrollTo(0, 0);
        next();
    },
}
</script>

<style lang="scss">
.book_req_section {

    .fa-times-circle-o,
    .custom_radio_btn_for_demo {
        display: none !important
    }
}
</style>
<style lang="scss" scoped>
@import url('../../../assets/fonts/acetone/style.css');

.membership_packages_wrp {
    min-height: 100dvh;
    padding-top: 65px;
    color: #FFFDD0;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;

    .book_req_section {
        background: rgba(0, 0, 0, 0.6);
        margin-top: 10px;
    }

    .membership_packages_bg_wrp {
        background: rgba(0, 0, 0, 0.92);
        padding: 30px 15px;
        position: relative;

        @media only screen and (max-width:1023px) {
            padding: 20px 10px;
        }
    }

    .membership_packages_heading {
        font-family: 'origin_tech_demoregular';
    }

    .card {
        background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(38, 38, 38, 0.6) 50%, rgba(44, 44, 84, 0.6) 100%);
        // background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 43, 170, 0.6) 50%, rgba(5, 2, 111, 0.7) 50%, rgba(64, 64, 77, 0.6) 100%);
        height: 100%;
    }

    .card-header {
        min-height: 200px;
        background: none;
        border-bottom: 1px solid rgba(161, 155, 155, 0.13);

        .card-title {
            font-size: 32px;
            color: #c4ffff;
            margin-bottom: 20px;
        }

        .card-subtitle {
            font-size: 20px;
            margin-bottom: 15px;
            color: #d981b3;
        }

        h6 {
            font-size: 30px;
        }
    }

    .card-body {
        padding: 10px 10px 85px;
        position: relative;

        .btn {
            position: absolute;
            bottom: 10px;
            left: 15px;
            right: 15px;
            width: calc(100% - 30px);
            padding: 14px 20px;
            font-size: 18px;
            line-height: 1;
            height: auto;
            border-radius: 8px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            box-shadow: none !important;

            &.request_demo_btn.btn-danger {
                border: 1px solid rgba(255, 255, 255, 0.2) !important;
                color: #ffffff;
                box-shadow: none !important;
                background: linear-gradient(140deg, rgba(151, 49, 49, 0.63) 0%, rgba(124, 18, 18, 0.8) 50%, rgba(180, 0, 0, 0.6) 50%, rgba(107, 23, 23, 0.6) 100%) !important;
                backdrop-filter: blur(12px);

                &:hover {
                    background: #87cefa !important;
                    border-color: #87cefa !important;
                    color: #22292f;
                }
            }

            &.btn-primary {
                background: rgba(135, 206, 250, 0.3);
                color: #ffffff;
                border: 1px solid rgba(135, 206, 250, 0.6);

                &:hover {
                    background: #FFFFC5;
                    color: #000000;
                    border-color: #FFFFC5;
                    color: #22292f;
                }

                &.active {
                    background: #006b18;
                    color: #ffffff;
                    cursor: default;
                    border: 1px solid #006b18;
                }
            }
        }
    }

    .listing_title {
        color: #ffc107;
        font-size: 22px;
        margin-bottom: 20px;
        text-align: center;
    }

    .packages_features_list {
        li {
            position: relative;
            padding-left: 30px;
            margin-bottom: 10px;
            font-size: 17px;

            &:last-child {
                margin-bottom: 0px;
            }

            .fa {
                position: absolute;
                left: 0px;
                top: 4px;
            }
        }
    }

    .login_signup_btn_transparent {
        font-family: 'ACETONE';
        background: none !important;
        border: 2px solid #ffe400 !important;
        color: #ffe400 !important;
        text-transform: uppercase;
        font-size: 28px;
        padding: 5px 8px;
        line-height: 1;
        height: auto;
        min-width: 110px;
        display: inline-block;
        border-radius: 6px;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        outline: none !important;
        text-decoration: none !important;

        &:hover {
            background: #ffe400 !important;
            color: #000000 !important;
        }
    }

    .membership_cancel {
        margin-top: 15px;

        .membership_cancel_txt {
            text-decoration: none;
            cursor: pointer;
            padding: 5px 10px 8px;
            color: #e4002b;
            font-size: 16px;
            background-color: rgba(31, 31, 31, 0.5);
            border-radius: 4px;
            line-height: 1;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            border: 1px solid rgba(174, 182, 184, 0.1);
            overflow: hidden;
            display: inline-block;
            font-weight: 500;
            position: relative;

            &::before {
                content: "";
                position: absolute;
                top: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(120deg,
                        transparent,
                        rgba(255, 255, 255, 0.2),
                        transparent);
                left: -100%;
                transition: all 0.65s ease-in-out;
            }

            &:hover {
                color: #ffd400;

                &::before {
                    left: 100%;
                }
            }
        }
    }

    &.package_list_login_wrp {
        .packages_features_list {
            margin-bottom: 0px;
        }

        .card-header {
            min-height: 220px;
            padding: 10px;
        }

        .box_style_change {
            .card {
                .card-header {
                    min-height: 185px;
                }
            }
        }

        @media only screen and (max-width:767px) {
            .packages_features_list {
                min-height: inherit !important;
                margin-bottom: 20px !important;
            }

            .card {
                min-height: inherit !important;
            }
        }
    }

    .seven_days_free_trial_alert {
        margin: 0;
        font-size: 20px;
        text-align: center;
        margin-top: 15px;
        line-height: 1;
        color: #ffec1e;
        font-weight: 500;
    }

    .home_rdrtc_cross {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        z-index: 100;
        padding: 4px 10px;
        color: #e4002b;
        font-size: 28px;
        background-color: rgba(31, 31, 31, 0.5);
        border-radius: 5px;
        line-height: 1;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        border: 1px solid rgba(174, 182, 184, 0.1);
        overflow: hidden;
        display: inline-block;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(120deg,
                    transparent,
                    rgba(255, 255, 255, 0.2),
                    transparent);
            left: -100%;
            transition: all 0.65s ease-in-out;
        }

        &:hover {
            box-shadow: 1px 1px 25px 10px rgba(255, 255, 255, 0.5) !important;
            color: #ffd400;

            &::before {
                left: 100%;
            }
        }
    }

    @media only screen and (min-width:1023px) {
        .packages_row {
            margin-left: -5px;
            margin-right: -5px;
        }

        .packages_row>.col-md-3 {
            padding-left: 5px;
            padding-right: 5px;
        }
    }

    @media only screen and (max-width:767px) {
        .packages_row >.col-md-3 {
            margin-top: 5px;
        }
    }
}
</style>